export default __webpack_public_path__ + "static/media/Fence's Cowl of Ushering Twilight.380a4644.jpg";